import React from 'react';
import { Result, Button } from 'antd';  // Importing Result and Button from Ant Design
import { useNavigate } from 'react-router-dom';


const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <div className='flex justify-center items-center h-screen text-center flex-col bg-[#f4f4f4]'
    >
      <Result
        status="500"
        title="500"
        subTitle="Sorry, something went wrong on our side."
        extra={
          <Button onClick={() => { navigate(-1) }} type="primary">
            Go Back
          </Button>
        }
      />
    </div>
  );
};

export default ErrorPage;
